import { Box, CircularProgress, Typography } from "@mui/material";
import MultiStepForm from "../../pages/agent/MultiStepForm";
import { useState, useEffect } from "react";

const AgentNewAdd = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 100);
    return () => clearTimeout(timer);
  }, []);

  if (!ready) {
    return (
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <CircularProgress />
        <Typography mt={2}>Preparing Agent Builder...</Typography>
      </Box>
    );
  }

  return <MultiStepForm mode="add" agentId={null} initialData={null} />;
};

export default AgentNewAdd;
